export function removeIds(obj) {
    return JSON.parse(
        JSON.stringify(obj, (key, value) => {
            if (key === 'id') return undefined;
            return value;
        })
    );
}
